import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/domains';
import { AxiosApi } from '@digibricks/plugin-axios';
import { ErrorResultHandler } from '@lib/domain-common';
import { Pagination } from '../../../core';
export var CONVERSATION_API = 'CONVERSATION_API';
export var ConversationApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(ConversationApi, _AxiosApi);

  var _super = _createSuper(ConversationApi);

  function ConversationApi(axiosInstance, conversationMapper) {
    var _this;

    _classCallCheck(this, ConversationApi);

    _this = _super.call(this, 'conversations', axiosInstance);
    _this.axiosInstance = axiosInstance;
    _this.conversationMapper = conversationMapper;
    return _this;
  }

  _createClass(ConversationApi, [{
    key: "getConversationsByResource",
    value: function () {
      var _getConversationsByResource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var jsonResponse, parsedResponseBody, conversations, _iterator, _step, dto, conversationResult, paginationResult;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.axios.get("".concat(this.url, "/by-resource"), {
                  params: {
                    resourceId: query.resourceId,
                    resourceType: query.resourceType,
                    limit: query.limit || 20,
                    nextToken: query.nextToken
                  }
                });

              case 3:
                jsonResponse = _context.sent;
                parsedResponseBody = jsonResponse.data;
                conversations = [];
                _iterator = _createForOfIteratorHelper(parsedResponseBody.data.items);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    dto = _step.value;
                    conversationResult = this.conversationMapper.toDomain(dto);

                    if (conversationResult.isSuccess) {
                      conversations.push(conversationResult.getValue());
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                paginationResult = Pagination.create({
                  items: conversations,
                  nextToken: parsedResponseBody.data.nextToken
                });

                if (!paginationResult.isFailure) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", Result.fail(paginationResult.error));

              case 11:
                return _context.abrupt("return", Result.ok(paginationResult.getValue()));

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 14]]);
      }));

      function getConversationsByResource(_x) {
        return _getConversationsByResource.apply(this, arguments);
      }

      return getConversationsByResource;
    }()
  }, {
    key: "createConversation",
    value: function () {
      var _createConversation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
        var jsonResponse, parsedResponseBody, conversationResult;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.axios.post(this.url, input);

              case 3:
                jsonResponse = _context2.sent;
                parsedResponseBody = jsonResponse.data;
                conversationResult = this.conversationMapper.toDomain(parsedResponseBody.data);

                if (!conversationResult.isFailure) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return", Result.fail(conversationResult.error));

              case 8:
                return _context2.abrupt("return", Result.ok(conversationResult.getValue()));

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 11]]);
      }));

      function createConversation(_x2) {
        return _createConversation.apply(this, arguments);
      }

      return createConversation;
    }()
  }, {
    key: "uploadFiles",
    value: function () {
      var _uploadFiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(conversationId, files) {
        var url, response, responseBody;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                url = "".concat(this.url, "/").concat(conversationId, "/files");
                _context3.next = 4;
                return this.axios.patch(url, {
                  files: files
                });

              case 4:
                response = _context3.sent;
                responseBody = response.data;
                return _context3.abrupt("return", Result.ok(responseBody.data.files));

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", ErrorResultHandler(_context3.t0));

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 9]]);
      }));

      function uploadFiles(_x3, _x4) {
        return _uploadFiles.apply(this, arguments);
      }

      return uploadFiles;
    }()
  }]);

  return ConversationApi;
}(AxiosApi);